import classNames from 'classnames';
import { FC } from 'react';

import { CirclePlaceholder, TextPlaceholder } from '@gem/components';

import styles from './SinglePlaceholder.styles.m.css';

export const SinglePlaceholder: FC = () => {
  return (
    <div className={classNames(styles.container)}>
      <CirclePlaceholder
        size={24}
        isAnimated
      />
      <div className={styles.content}>
        <TextPlaceholder
          className={styles.gap}
          width={140}
        />
        <TextPlaceholder
          className={styles.gap}
          width={110}
        />
        <TextPlaceholder
          className={styles.gap}
          width={110}
        />
      </div>
    </div>
  );
};
